// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';
import TOPIC_OFFSET from './TopicOffset';

const EditTopicTree = () => {

   const [file, set_file] = React.useState(false);
   const [json, set_json] = React.useState();
   const [TREE, set_tree] = React.useState();

   const [btn_add, set_btn_add]  = React.useState(false);
   const [btn_del, set_btn_del]  = React.useState(false);
   const [btn_dwn, set_btn_dwn]  = React.useState(false);
   const [btn_upw, set_btn_upw]  = React.useState(false);

   const EMPTY_NODE   = [ 0, 0, 0, 0, 0, 0, 0, null, 0, 0, 0, 0 ];

   const LEVEL        = TOPIC_OFFSET.LEVEL;
   const PARENT       = TOPIC_OFFSET.PARENT;
   const FIRST_CHILD  = TOPIC_OFFSET.FIRST_CHILD;
   const IS_PARENT    = TOPIC_OFFSET.IS_PARENT;
   const NEXT         = TOPIC_OFFSET.NEXT_SIBLING;
   const TEXT         = TOPIC_OFFSET.TEXT;
   const INFO_ID      = TOPIC_OFFSET.INFO_ID;
   const DETAILS      = TOPIC_OFFSET.DETAILS;

   const OPEN         = DETAILS + 1;
   const PICK         = DETAILS + 2;
   const SHOW         = DETAILS + 3;
   const PREV         = DETAILS + 4;
   const LAST         = DETAILS + 5;

   const details_ref  = React.useRef();
   const topic_ref    = React.useRef();

   var content   = [];

   var key_index = 1;

   const tree    = TREE ? JSON.parse(TREE) : null;

   const begin = async ({ set_form, set_warn, ...args }) => {
      // The begin() function initiates an API call to get information required to build the form. If no
      // information is needed then you can omit the begin() function or just set the form state to BUILD;

      var response = await api.fetch('key/tree/' + app.state.user_access_list[app.state.user_access_id].version_id, api.post());
      if (!response.good && (404 !== response.stat)) {
         set_warn('undefined' === typeof response.data.text ? 'Unrecognized API errror.' : response.data.text);
      } else {
         var tree = [];
         if (404 === response.stat) {
            tree[0]          = EMPTY_NODE;
            tree[0][0]       = 1;
            tree[1]          = EMPTY_NODE;
            tree[1][LEVEL]   = 1;
            tree[1][TEXT]    = 'Topic ' + (tree.length - 1);
            tree[1][DETAILS] = null;
            tree[1][OPEN]    = false;
            tree[1][PICK]    = false;
            tree[1][SHOW]    = 'show';
         } else {
            tree       = response.data.tree;
            tree[0]    = EMPTY_NODE;
            tree[0][0] = 1;
            for (var node = 1; node < tree.length; node++) {
               tree[node][OPEN] = false;
               tree[node][PICK] = false;
               tree[node][SHOW] = (1 === tree[node][LEVEL]) ? 'show' : 'hide';
               // Load parent's last child index;
               if (tree[node][PARENT]) tree[ tree[node][PARENT] ][LAST] = node;
               // Load this nodes previous sibling's index;
               for (var jth = 1; jth < tree.length; jth++) {
                  if (node === tree[jth][NEXT]) {
                     tree[node][PREV] = jth;
                     break;
                  }
               }
            }
         }
         set_tree(JSON.stringify(tree));
      }
      set_form(FORM.BUILD);
   } // begin();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      if (tree) build_node_render(tree[0][0], args);

      set_body(
         <>
           {warn}
           <p className="ask-henry-body-margin-bottom-x">Select a topic to edit:</p>
           <input className="ask-henry-keyword-edit ask-henry-form-input" name="keyword" onChange={(e) => build_topic_on_change(e, args)} ref={topic_ref} type="text" />
           <input className="ask-henry-keyword-edit ask-henry-form-input" disabled={!file} name="details" onChange={(e) => build_details_on_change(e, args)} ref={details_ref} type="text" />
           <button  
             className={'ask-henry-keyword-edit-icon ' + (btn_del ? 'ask-henry-form-button' : 'ask-henry-form-button-disabled')} 
             onClick={(e) => build_node_add(e, args)}
             title={btn_del ? 'Add topic under selected topic' : ''}
           >add</button>

           <button
             className={'ask-henry-keyword-edit-icon ' + (btn_add ? 'ask-henry-form-button' : 'ask-henry-form-button-disabled')} 
             onClick={(e) => build_node_add_child(e, args)}
             title={btn_add ? 'Add child topic under selected topic' : ''}
           >new_label</button>

           <button 
             className={'ask-henry-keyword-edit-icon ' + (btn_upw ? 'ask-henry-form-button' : 'ask-henry-form-button-disabled')} 
             data-direction="up" 
             onClick={(e) => build_node_move(e, args)}
             title={btn_upw ? 'Move selected topic up' : ''}
           >arrow_upward</button>

           <button 
             className={'ask-henry-keyword-edit-icon ' + (btn_dwn ? 'ask-henry-form-button' : 'ask-henry-form-button-disabled')} 
             data-direction="down" 
             onClick={(e) => build_node_move(e, args)}
             title={btn_dwn ? 'Move selected topic down' : ''}
           >arrow_downward</button>

           <button 
             className={'ask-henry-keyword-edit-icon ' + (btn_del ? 'ask-henry-form-button' : 'ask-henry-form-button-disabled')} 
             onClick={(e) => build_node_delete(e, args)} 
             title={btn_del ? 'Delete selected topic' : ''}
           >delete</button>

           <div className="ask-henry-keyword-edit-scroll" key={key_index++}>{content}</div>
         </>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Save{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
         </>
      );

   } // build();

   const build_details_on_change = (event, args) => {

      var node = build_node_selected();

      if (!node) return;

      tree[node][DETAILS] = event.target.value;

      build_set_tree(args);

   }; // build_details_on_change();

   const build_node_add = (event, args) => {

      event.preventDefault();

      if (!btn_del) return; // Add/delete both only require a selected node;

      var node     = build_node_selected();

      var new_node = tree.length;

      if (tree[node][NEXT]) tree[tree[node][NEXT]][PREV] = new_node;
      tree[new_node]          = EMPTY_NODE;
      tree[new_node][LEVEL]   = tree[node][LEVEL];
      tree[new_node][PARENT]  = tree[node][PARENT];
      tree[new_node][PREV]    = node;
      tree[new_node][NEXT]    = tree[node][NEXT];
      tree[new_node][TEXT]    = 'Topic ' + (tree.length - 1);
      tree[new_node][PICK]    = true;
      tree[new_node][SHOW]    = 'show';
      tree[node][NEXT]        = new_node;
      tree[node][PICK]        = false;

      topic_ref.current.value = tree[new_node][TEXT];

      build_set_tree(args);

   } // build_node_add();

   const build_node_add_child = (event, args) => {

      event.preventDefault();

      if (!btn_add) return;

      var node     = build_node_selected();

      var new_node = tree.length;

      tree[node][FIRST_CHILD] = new_node;
      tree[node][PICK]        = false;
      tree[new_node]          = EMPTY_NODE;
      tree[new_node][LEVEL]   = tree[node][LEVEL] + 1;
      tree[new_node][PARENT]  = node;
      tree[new_node][TEXT]    = 'Topic ' + (tree.length - 1);
      tree[new_node][PICK]    = true;
      tree[new_node][SHOW]    = 'show';

      topic_ref.current.value = tree[new_node][TEXT];

      build_set_tree(args);

   } // build_node_add_child();

   const build_node_delete = (event, args) => {

      event.preventDefault();

      if (!btn_del) return; // Add/delete both only require a selected node;

      var node = build_node_selected();

      if (!node) return;

      var next   = tree[node][NEXT];
      var parent = tree[node][PARENT];
      var prev   = tree[node][PREV];

      if (next) {
         tree[next][PICK] = true;
      } else if (prev) {
         tree[prev][PICK] = true;
      } else if (parent) {
         tree[parent][PICK] = true;
      }

      if (prev) tree[prev][NEXT] = next;
      if (next) tree[next][PREV] = prev;

      if (tree[parent][FIRST_CHILD] === node) tree[parent][FIRST_CHILD] = next;

      tree[node] = EMPTY_NODE;

      build_set_tree(args);

   } // build_node_delete();

   const build_node_move = (event, args) => {

      event.preventDefault();

      var swap = 0;

      var node = build_node_selected();

      if (!node) return;

      const up = 'up' === event.target.getAttribute('data-direction');

      var sub0 = (1 === tree[node][LEVEL]) ? 0 : tree[node][PARENT];
      var sub1 = (1 === tree[node][LEVEL]) ? 0 : FIRST_CHILD;

      if (up) {

         if (!btn_upw) return;

         swap = tree[node][PREV];

         if (!swap) return;

         // IF up move puts node first in tree;
         if (swap === tree[sub0][sub1]) tree[sub0][sub1] = node;

         if (tree[swap][PREV]) tree[tree[swap][PREV]][NEXT] = node;
         if (tree[node][NEXT]) tree[tree[node][NEXT]][PREV] = swap;

         tree[swap][NEXT] = tree[node][NEXT];
         tree[node][PREV] = tree[swap][PREV];
         tree[node][NEXT] = swap;
         tree[swap][PREV] = node;

      } else {

         if (!btn_dwn) return;

         swap = tree[node][NEXT];

         if (!swap) return;

         // IF down move puts swap first in tree;
         if (node === tree[sub0][sub1]) tree[sub0][sub1] = swap;

         if (tree[swap][NEXT]) tree[tree[swap][NEXT]][PREV] = node;
         if (tree[node][PREV]) tree[tree[node][PREV]][NEXT] = swap;

         tree[swap][PREV] = tree[node][PREV];
         tree[node][NEXT] = tree[swap][NEXT];
         tree[node][PREV] = swap;
         tree[swap][NEXT] = node;

      }

      build_node_status(node);

      build_set_tree(args);

   } // build_node_move();

   const build_node_render = (node, args) => {

      while (node) {

         var child = tree[node][FIRST_CHILD];
         var icon  = '';
         var level = 'ask-henry-keyword-edit-icon-' + tree[node][LEVEL];
         var show  = 'ask-henry-keyword-edit-' + (tree[node][PICK] ? 'pick' : tree[node][SHOW]);

         if (child) {
            icon   = tree[node][OPEN] ? 'keyboard_arrow_down' : 'keyboard_arrow_right';
         } else {
            if (tree[node][INFO_ID]) icon = 'description';
         }

         content.push(
            <div className={show} data-idx={node} key={key_index++} onClick={(e) => build_node_select(e, args)}>
              <div className={level} data-idx={node} key={key_index++} >{icon}</div>
              <div className="ask-henry-keyword-edit-word" data-idx={node} key={key_index++} >{tree[node][TEXT]}</div>
            </div>
         );

         if (tree[node][PICK]) {
            set_btn_del(true);
            if (!tree[node][FIRST_CHILD]) button_add_kid = 'ask-henry-form-button ask-henry-keyword-edit-icon';
            set_btn_dwn(tree[node][NEXT]);
            set_btn_upw(tree[node][PREV]);
         }

         if (child) build_node_render(child, args);

         node = tree[node][NEXT];

      }

   } // build_node_render();

   const build_node_select = (event, args) => {

      // Load the state of the clicked node;
      var click  = event.target.getAttribute('data-idx');

      if (!click) return;

      var child  = tree[click][FIRST_CHILD];
      var open   = tree[click][OPEN];
      var parent = tree[click][PARENT];

      // IF clicked on non-parent (leaf) node;
      if (!tree[click][IS_PARENT]) {

         set_file(true); // Enable the details input field;

         for (var node = 1; node < tree.length; node++) {
            tree[node][PICK] = false;
         }

      } else { // ELSE parent node;

         set_file(false); // Disable the details input field;

         // Close all but top level nodes;
         for (let node = 1; node < tree.length; node++) {
            tree[node][OPEN] = false;
            tree[node][PICK] = false;
            tree[node][SHOW]
               = (1 === tree[node][LEVEL]) 
               ? 'show' 
               : 'hide';
         }

         // IF this node was closed;
         if (!open) {
            // Show all children;
            while (child) {
               tree[child][SHOW] = 'show';
               child = tree[child][NEXT];
            }
            tree[click][OPEN] = true;
            tree[click][SHOW] = 'show';
         } // ENDIF this parent node was closed;

         // IF this node has a parent node (not top level);
         while (parent) {
            tree[parent][OPEN] = true;
            tree[parent][SHOW] = 'show';
            let child = tree[parent][FIRST_CHILD];
            // Show all parent node children;
            while (child) {
               tree[child][SHOW] = 'show';
               child = tree[child][NEXT];
            }
            parent = tree[parent][PARENT];
         }

      } // ENDIF parent node;

      tree[click][PICK] = true;

      topic_ref.current.value   = tree[click][TEXT];

      details_ref.current.value = tree[click][DETAILS];

      build_node_status(click);

      build_set_tree(args);

   } // build_node_select();

   const build_node_selected = () => {
      for (var node = 1; node < tree.length; node++) {
         if (tree[node][PICK]) return node;
      }
      return 0;
   } // build_node_selected();

   const build_set_tree = (args) => {
      set_tree(JSON.stringify(tree));
      args.set_pass(args.pass + 1);
   } // build_set_tree();

   const build_node_status = (node) => {
      if (node) {
         set_btn_add(!tree[node][FIRST_CHILD]);
         set_btn_del(true);
         set_btn_dwn(tree[node][NEXT]);
         set_btn_upw(tree[node][PREV]);
      } else {
         set_btn_add(false);
         set_btn_del(false);
         set_btn_dwn(false);
         set_btn_upw(false);
      }
   } // build_node_status();

   const build_topic_on_change = (event, args) => {

      var node = build_node_selected();

      if (!node) return;

      tree[node][TEXT] = event.target.value;

      build_set_tree(args);

   }; // build_topic_on_change();

   var button_add_kid  = 'ask-henry-form-button-disabled ask-henry-keyword-edit-icon';

   const enact = async ({ set_body, set_foot, set_form, set_pass, set_warn, pass, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      set_warn('');

      var response = await api.fetch('dbs/tree/stream/' + app.state.version_id, api.post({ topics:enact_tree2array() }), api.token());

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD);
      } else {
         set_form(FORM.FINAL);
         set_json(response.data);
         app.set_state('status', 'Topic tree edited');
      }

   } // enact();

   const enact_tree2array = () => {
      const array = [];
      const enact_tree2array_node = (node) => {
         while (node) {
            var child   = tree[node][FIRST_CHILD];
            var level   = tree[node][LEVEL];
            var details = tree[node][DETAILS] ? ' (' + tree[node][DETAILS] + ')' : '';
            array.push('  '.repeat(level - 1) + '- ' +  tree[node][TEXT] + details)
            if (child) enact_tree2array_node(child);
            node = tree[node][NEXT];
         }
      } // enact_tree2array_node();
      if (tree) enact_tree2array_node(tree[0][0]);
      return array;
   } // enact_tree2array();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">{json.message}</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form begin={begin} build={build} class_string="ask-henry-form-keyword-edit" enact={enact} final={final} title={'Edit Topic Tree' + app.who()} />

} // <EditTopicTree />;

export default EditTopicTree;
